module.exports = __webpack_public_path__ + "static/media/download.452de7c9.svg";